module.exports = __webpack_public_path__ + "static/media/QKC.77ff72fc.svg";